import {AuswahlProdukt, Feature, SelectedFeature} from "@k/js/product";
import {Store} from "vuex";
import {ProduktWechselDataInteractor} from "@km/components/productChange/ProduktWechselDataInteractor";
import {ProduktAuswahlProdukt} from "@km/store/ProduktAuswahlStore";



export class ProduktWechselDataInteractorMobile implements ProduktWechselDataInteractor {
    private store: Store<any>;

    public constructor(store:Store<any>) {
        this.store = store;
    }
    closePopup = (popupname: string) => this.store.commit("SET_OVERLAY_CLOSED", popupname);
    openPopup = (popupname: string) => this.store.commit("SET_OVERLAY_OPEN", popupname);
    getCurrentOwayoProduct = () => this.store.getters["ModelStore/getCurrentOwayoProduct"];
    getEntwurfModel = () => this.store.getters.getModel;
    getStagedProductModel = () => this.store.getters.getStagedproductModel;
    useStagedProductAsCurrentProduct = () => this.store.dispatch("useStagedProductAsCurrentProduct");
    getCurrentDesigname = () => this.store.getters.getCurrentDesignname;
    getStagedProduct = () => this.store.getters.getStagedProduct;
    getAuswahlProdukt = (s: string) => this.store.getters.getProductByProdukt(s);
    stageProduct = (auswahlProdukt: AuswahlProdukt|ProduktAuswahlProdukt, features: SelectedFeature[], data: any) => this.store.commit("STAGE_PRODUCT", {
        auswahlProdukt,
        features,
        data
    });
    loadProductPreviewPic = () => this.store.dispatch("loadProductPreviewPic");
    getWebsportFuerProduktAuswahlNormalized = () => this.store.getters["ModelStore/getWebsportFuerProduktAuswahlNormalized"];
    getLanguage = () => this.store.getters["ModelStore/getLanguageIso"];
    getOwayoDirectLogin = () => this.store.getters["ModelStore/getOwayoDirectLogin"];
    getChoosableFeatures = (productname: string) => this.store.getters.getChoosableFeatures(productname);
    setStagedFeature = (data: {
        featuredObjectname: string;
        feature: Feature;
    }) => this.store.commit("SET_STAGED_SELECTED_FEATURE", data);
    getStagedAuswahlProdukt = () => this.store.getters.getStagedAuswahlProdukt;
    getStagedProductSelectedFeatures = () => this.store.getters.getStagedProductSelectedFeatures;
}